import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { DialogActionService } from 'src/app/Services/dialog-actions.service';
import { FileUploadService } from 'src/app/Services/file-upload.service';
import { SnackBarService } from 'src/app/Services/snackbar.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { OrgModule } from '../../../../modules/organization';
import { alertSettings } from '../../../../modules/organization/alert-settings';
declare const popup: any, snackbar: any;

export interface User {
  name: string;
}

const urlPattern = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';

import indiaStates from './../../../../../assets/js/india.state.list.json';
export interface Subject {
  name: string;
  phone: number;
}

@Component({
  selector: 'app-createorg',
  templateUrl: './createorg.component.html',
  styleUrls: ['./createorg.component.css']
})

export class CreateOrgComponent {

  public organization;
  public alertSettings;
  isUserShow = true;
  isAlertShow: any;
  isServiceShow: boolean;
  settingsInfo: any = {};
  test: any = {};
  alertFunName: string;
  isEnableClickCard: boolean;
  valueCount: any;
  setInfoLgth: any;
  systoken: any;
  selectedIndex: number = 0;
  createOrgDataDetails: any;
  userType: string;

  /* Form variables */
  public addOrganizationForm: FormGroup;
  public stateSelect = indiaStates.IND;
  public options: User[] = [];
  public profileImage: any;
  public createFormSubmit: boolean = false;
  matFormSize = '13px';
  // settings
  public addSettingsForm: FormGroup;
  public settingsFormSubmit: boolean = false;

  public enableUserSettings: boolean = false;
  public showExcelFieldMap: boolean = false;
  public orgID = '';

  public activeMenu: string = 'Field Map';

  public headers: any = [];
  public userRestrictionData: any = {}
  public tableData: any = {};

  public dropdownOptions = 'single';

  public generalSettingsList: any = [
    {
      setting: 'Multi trip start', value: 'multiTripStart', checked: false
    },
    {
      setting: 'Employee app polyline', value: 'empAppPolyline', checked: false
    },
    {
      setting: 'Click to call', value: 'click2call', checked: false
    }, {
      setting: 'Breakdown', value: 'breakDown', checked: false
    }, {
      setting: 'Event', value: 'event', checked: false
    }, {
      setting: 'Self Attendance by Employee', value: 'selfAttendanceForEmp', checked: false
    }, {
      setting: 'Harsh Acceleration Braking', value: 'harshAccBraking', checked: false
    }
  ]

  public general = {
    multiTripStart: false,
    empAttendance: '',
    empAppPolyline: false,
    driverTokenExp: 1,
    click2call: false,
    breakDown: false,
    event: false,
    selfAttendanceForEmp: false,
    driverTrackingInterval: 10,
    harshAccBraking: false,
    harshAccThreshold: 1.8,
    harshBrakingThreshold: 1.8
  }

  disableTrue: boolean = false;
  disableTrue2: boolean = false;
  disableTrue3: boolean = false;
  disableTrue4: boolean = false;
  errorContent: string;
  brakingDisable: boolean = false;
  errorContentHarshAcc: string;
  errorContentHarshBreak: string;
  constructor(
    public api: ApiService,
    public router: Router,
    public snackBar: SnackBarService,
    public storage: StorageService,
    public swal: SweetAlert,
    public file: FileUploadService,
    public fb: FormBuilder,
    public dialogService: DialogActionService) {
    this.userType = this.storage.get('userType');
  }

  ngOnInit() {
    if (this.userType != 'maste-admin') {
      this.router.navigate(['/master/login']);
    }

    this.getStateOptions();
    this.addFormLoad();
    this.settingFormLoad();
    // this.getUserRestictionList();
    // this.organization = OrgModule;
    // this.alertSettings = alertSettings;

    // // state arrays ------
    // const states = {};
    // const stateList = this.getStateOptions();
    // for (const item of this.organization) {
    //   if (item.name == 'state') {
    //     item.options = stateList;
    //   }
    //   if (item.name == 'country') {
    //     item.value = 'India';
    //   }
    //   console.log(item);
    // }
    // ----------------
    this.findActiveMenu(this.activeMenu);
  }

  // -------------------------------
  getStateOptions() {
    this.stateSelect.forEach(element => { this.options.push({ name: element }) });
  }

  /* add form load */

  addFormLoad() {
    this.addOrganizationForm = new FormGroup({
      orgName: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z-_&, ]*$')]),   //Validators.minLength(5)
      orgEmail: new FormControl('', [Validators.required, Validators.email]),
      website: new FormControl('', [Validators.required, Validators.pattern(urlPattern)]),
      country: new FormControl('India', [Validators.required]),
      state: new FormControl('', [Validators.required]),
      city: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z-& ]*$')]),
      address: new FormControl('', [Validators.required]),
      pincode: new FormControl('', [Validators.required, Validators.pattern('[0-9]\\d{5}')]),
      primaryContactName: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z-_&, ]*$')]),   //Validators.minLength(5)
      primaryContactEmail: new FormControl('', [Validators.required, Validators.email]),
      primaryContactNumber: new FormControl('', [Validators.required, Validators.pattern('[0-9]\\d{9}')]),
      primaryContactRole: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z-_&, ]*$')]),   //Validators.minLength(5)
      secondaryContactName: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z-_&, ]*$')]),   //Validators.minLength(5)
      secondaryContactEmail: new FormControl('', [Validators.required, Validators.email]),
      secondaryContactNumber: new FormControl('', [Validators.required, Validators.pattern('[0-9]\\d{9}')]),
      secondaryContactRole: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z-_&, ]*$')]),   //Validators.minLength(5)
      map: new FormControl('osrm'),
      profile: new FormControl(''),
    });
  }
  settingFormLoad() {
    this.addSettingsForm = this.fb.group({
      name: ['', Validators.required],
      userEmail: ['', [Validators.required, Validators.email]],
      designation: ['', [Validators.required]],
      contactNumber: ['', [Validators.required, Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$')]],
      call: [false],
      email: [false],
      push: [false],
      sms: [false],
      empSolution: [false],
      fleet: [false],
    });
  }
  async getUserRestictionList() {

    let obj = {
      "orgID": this.orgID
    }
    let settingList;
    await this.api.masterOrgFieldMapSettingList(obj).then((res: any) => {
      if (res.status == "success") {
        settingList = res['data'][0]['fieldMap'];
      }
    });

    if (settingList != undefined) {
      this.userRestrictionData = JSON.parse(JSON.stringify(settingList));
      this.tableData = JSON.parse(JSON.stringify(settingList));
      this.headers = Object.keys(this.tableData);
    }
  }

  /* Invidual form field check */
  public checkError = (form, controlName: string, errorName: string) => {
    return this[form].controls[controlName].hasError(errorName);
  }
  async handleUpload(event) {
    this.profileImage = await this.file.fileHandeleBase64(event);
    this.addOrganizationForm.controls.profile.patchValue(this.profileImage);
  }
  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();

    }
  }
  reUpload(field) {
    document.getElementById(field).click();
  }

  cancelImage() {
    this.profileImage = '';
    this.addOrganizationForm.controls.profile.patchValue('');
  }
  // --------------------------

  submitted() {
    this.createFormSubmit = true;
    let obj = { ...this.addOrganizationForm.value };
    obj.orgEmail = obj.orgEmail.toLowerCase();
    obj.primaryContactEmail = obj.primaryContactEmail.toLowerCase();
    obj.secondaryContactEmail = obj.secondaryContactEmail.toLowerCase();
    obj.fieldMap = this.userRestrictionData;
    if (!this.addOrganizationForm.valid) { return; }
    // console.log(this.addOrganizationForm.value,this.addOrganizationForm);
    if (this.addOrganizationForm.valid) {

      let obj = { ...this.addOrganizationForm.value };
      obj.orgEmail = obj.orgEmail.toLowerCase();
      obj.primaryContactEmail = obj.primaryContactEmail.toLowerCase();
      obj.secondaryContactEmail = obj.secondaryContactEmail.toLowerCase();
      obj.fieldMap = this.userRestrictionData;
      this.api.createOrg(obj).then((res: any) => {
        if (res.status == 'success') {
          const msg = res.message + 'please follow and complete setings and mapping';
          this.swal.swalFunction(res.status, res.status, msg, 5000);
          this.orgID = res.orgID;
          this.storage.setData({ orgID: res.orgID });
          this.enableUserSettings = true;
          this.showExcelFieldMap = true;
          this.selectedIndex = 1;
          // this.router.navigate(['/master/view-org'])
        } if (res.status == 'failure') {
          this.swal.swalFunction('error', res.status, res.message, 2000);
        }
      })
        .catch((error: any) => {
          console.log('Error', error);
        });
    } else {
      console.log('form missing');
    }
  }


  draft(e: any) {
    console.log(e);
  }

  createUserFun(val) {
    switch (val) {
      case 'user':

        this.isUserShow = true;
        this.isServiceShow = false;
        this.isAlertShow = false;
        break;
      case 'alert':
        let allow;
        this.settingsInfo.userInfo ? allow = true : allow = false;
        if (allow) {
          this.isAlertShow = true;
          this.isUserShow = false;
          this.isServiceShow = false;
        }
        break;
      case 'services':
        let serviceAllow;
        this.settingsInfo.alert ? serviceAllow = true : serviceAllow = false;
        if (serviceAllow) {
          this.isServiceShow = true;
          this.isAlertShow = false;
          this.isUserShow = false;
        }

        break;
    }
  }


  receivingDataFromPrimaryAdmin(e) {
    // console.log(e);
    this.settingsInfo.userInfo = e;
    // console.log(Object.values(this.settingsInfo));
    const objLength = Object.values(this.settingsInfo);
    // console.log(objLength.length);
    this.createUserFun('alert');
    this.storage.setData({ settingsInfoData: this.settingsInfo });
  }
  receivingDataFromAlerts(e) {
    // console.log('alertInfo', e);
    this.settingsInfo.alert = e;
    // console.log(Object.values(this.settingsInfo));
    const objLength = Object.values(this.settingsInfo);
    this.createUserFun('services');
    // console.log(objLength.length);
    this.storage.setData({ settingsInfoData: this.settingsInfo });
  }
  receivingDataFromSrvices(e) {
    // console.log('receivingDataFromSrvices', e);
    this.settingsInfo.service = e;
    // console.log('final', this.settingsInfo);
    // this.router.navigate(['/master/view/org'])
    // console.log(Object.values(this.settingsInfo))
    // let va = Object.values(this.settingsInfo)
    const obj = {
      //orgID: this.storage.get('orgId'),
      ...this.settingsInfo
    };
    this.api.org_settings(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.router.navigate(['/master/organization/view-org']);
      }
      if (res.status == 'failure') {
        console.log('settings error');
        const msg = [];
        const rstmsg = res.message;
        console.log(rstmsg.orgID);
        rstmsg.orgID.forEach(function (eror) {
          console.log(eror);
          this.msg.push(eror);
        });

        this.swal.swalFunction('error', res.status, msg, 2000);
      }

    })
      .catch((err) => {
        console.log(err);
      });
  }
  settingsSubmit() {
    this.settingsFormSubmit = true;
    // console.log(this.addSettingsForm.value,this.addSettingsForm);
    if (!this.addSettingsForm.valid) { return; }
    if (this.addSettingsForm.valid) {
      const obj = {
        userInfo: {
          name: this.addSettingsForm.value.name,
          userEmail: this.addSettingsForm.value.userEmail,
          designation: this.addSettingsForm.value.designation,
          contactNumber: this.addSettingsForm.value.contactNumber,
        },
        service: {
          empSolution: this.addSettingsForm.value.empSolution,
          fleet: this.addSettingsForm.value.fleet,
        },
        alert: {
          email: this.addSettingsForm.value.email,
          call: this.addSettingsForm.value.call,
          push: this.addSettingsForm.value.push,
          sms: this.addSettingsForm.value.sms,
        },
        map: this.addSettingsForm.value.map,
        orgID: this.orgID
      };
      // console.log(obj)
      this.api.org_settings(obj).then((res: any) => {
        if (res.status == 'success') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          // this.router.navigate(['/master/organization/view-org']);
          this.getUserRestictionList()
        }
        if (res.status == 'failure') {
          console.log('settings error');
          const msg = [];
          const rstmsg = res.message;
          // console.log(rstmsg.orgID);
          rstmsg.orgID.forEach(function (eror) {
            console.log(eror);
            this.msg.push(eror);
          });

          this.swal.swalFunction('error', res.status, msg, 2000);
        }

      })
        .catch((err) => {
          console.log(err);
        });
    }
  }
  findActiveMenu(menu) {
    this.activeMenu = menu;
  }

  //for field map
  showNestedData(id) {
    let btn = document.getElementById(id);
    if (btn.classList.contains('fa-chevron-down')) {
      btn.classList.replace('fa-chevron-down', 'fa-chevron-up');
    } else {
      btn.classList.replace('fa-chevron-up', 'fa-chevron-down');
    }
  }
  selectModule(event, value, moduleIndex) {
    this.tableData[value].checked = event;
    this.tableData[value].indeterminate = false;
    if (this.tableData[value].menu1) {
      let sub1 = this.tableData[value].menu1;
      let subModules1 = Object.keys(sub1);
      for (let i = 0; i < subModules1.length; i++) {
        sub1[subModules1[i]].checked = event;
        sub1[subModules1[i]].indeterminate = false;

        if (sub1[subModules1[i]].menu2) {
          let sub2 = sub1[subModules1[i]].menu2;
          let subModules2 = Object.keys(sub2);
          for (let j = 0; j < subModules2.length; j++) {
            sub2[subModules2[j]].checked = event;
            sub2[subModules2[j]].indeterminate = false;

            if (sub2[subModules2[j]].menu3) {
              let sub3 = sub2[subModules2[j]].menu3;
              let subModules3 = Object.keys(sub3);
              for (let k = 0; k < subModules3.length; k++) {
                sub3[subModules3[k]].checked = event;
                sub3[subModules3[k]].indeterminate = false;
              }
            }
          }
        }
      }
    }
  }
  selectSubmodule1(event, selectedModule, selectedSubmodule1, moduleIndex, subModule1Index) {
    this.tableData[selectedModule].menu1[selectedSubmodule1].checked = event;
    this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate = false;
    // this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate=!event;
    if (this.tableData[selectedModule].menu1[selectedSubmodule1].menu2) {
      let sub2 = this.tableData[selectedModule].menu1[selectedSubmodule1].menu2;
      let subModules2 = Object.keys(sub2);
      for (let i = 0; i < subModules2.length; i++) {
        sub2[subModules2[i]].checked = event;
        sub2[subModules2[i]].indeterminate = false;

        if (sub2[subModules2[i]].menu3) {
          let sub3 = sub2[subModules2[i]].menu3;
          let subModules3 = Object.keys(sub3);
          for (let j = 0; j < subModules3.length; j++) {
            sub3[subModules3[j]].checked = event;
            sub3[subModules3[j]].indeterminate = false;
          }
        }
      }
    }
    this.checkModuleIndeterminateOrChecked(event, selectedModule);
  }
  checkModuleIndeterminateOrChecked(event, selectedModule) {
    let sub1 = this.tableData[selectedModule].menu1;
    let subModules1 = Object.keys(sub1);
    let isValid = true;
    for (let i = 0; i < subModules1.length; i++) {
      if ((sub1[subModules1[i]].checked == false || sub1[subModules1[i]].checked == undefined || sub1[subModules1[i]].indeterminate == false)) {
        isValid = false;
        break;
      } else {
        isValid = true;
      }
    }
    if (isValid) {
      this.tableData[selectedModule].checked = isValid;
      this.tableData[selectedModule].indeterminate = !isValid;
    } else {
      let checkArr = [];
      let indeterArr = [];
      for (let i = 0; i < subModules1.length; i++) {
        if (sub1[subModules1[i]].checked) {
          checkArr.push('checked');
        } else if (sub1[subModules1[i]].indeterminate) {
          indeterArr.push('indeterminate');
        }
      }
      if (checkArr.length <= 0 && indeterArr.length <= 0) {
        this.tableData[selectedModule].indeterminate = isValid;
        this.tableData[selectedModule].checked = isValid;
      } else if (checkArr.length == subModules1.length) {
        this.tableData[selectedModule].checked = !isValid;
        this.tableData[selectedModule].indeterminate = isValid;
      } else if (indeterArr.length == subModules1.length) {
        this.tableData[selectedModule].indeterminate = !isValid;
        this.tableData[selectedModule].checked = isValid;
      } else {
        this.tableData[selectedModule].indeterminate = !isValid;
        this.tableData[selectedModule].checked = isValid;
      }
    }
  }
  selectSubmodule2(event, selectedModule, selectedSubmodule1, selectedSubmodule2, moduleIndex, subModule1Index, subModule2Index) {
    this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].checked = event;
    this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].indeterminate = false;
    if (this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].menu3) {
      let sub3 = this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].menu3;
      let subModules3 = Object.keys(sub3);
      for (let i = 0; i < subModules3.length; i++) {
        sub3[subModules3[i]].checked = event;
      }
    }
    this.checkSubmodule1IndeterminateOrChecked(event, selectedModule, selectedSubmodule1);
  }
  checkSubmodule1IndeterminateOrChecked(event, selectedModule, selectedSubmodule1) {
    let sub2 = this.tableData[selectedModule].menu1[selectedSubmodule1].menu2;
    let subModules2 = Object.keys(sub2);
    let isValid = true;
    for (let i = 0; i < subModules2.length; i++) {
      if ((sub2[subModules2[i]].checked == false || sub2[subModules2[i]].checked == undefined || sub2[subModules2[i]].indeterminate == false)) {
        isValid = false;
        break;
      } else {
        isValid = true;
      }
    }
    if (isValid) {
      this.tableData[selectedModule].menu1[selectedSubmodule1].checked = isValid;
      this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate = !isValid;
    } else {
      let checkArr = [];
      let indeterArr = [];
      for (let i = 0; i < subModules2.length; i++) {
        if (sub2[subModules2[i]].checked) {
          checkArr.push('checked');
        } else if (sub2[subModules2[i]].indeterminate) {
          indeterArr.push('indeterminate');
        }
      }
      if (checkArr.length <= 0 && indeterArr.length <= 0) {
        this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate = isValid;
        this.tableData[selectedModule].menu1[selectedSubmodule1].checked = isValid;
      } else if (checkArr.length == subModules2.length) {
        this.tableData[selectedModule].menu1[selectedSubmodule1].checked = !isValid;
        this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate = isValid;
      } else if (indeterArr.length == subModules2.length) {
        this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate = !isValid;
        this.tableData[selectedModule].menu1[selectedSubmodule1].checked = isValid;
      } else {
        this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate = !isValid;
        this.tableData[selectedModule].menu1[selectedSubmodule1].checked = isValid;
      }
    }
    this.checkModuleIndeterminateOrChecked(event, selectedModule);
  }
  selectSubmodule3(event, selectedModule, selectedSubmodule1, selectedSubmodule2, selectedSubmodule3, moduleIndex, subModule1Index, subModule2Index, subModule3Index) {
    this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].menu3[selectedSubmodule3].checked = event;
    this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].menu3[selectedSubmodule3].indeterminate = false;
    this.checkSubmodule2IndeterminateOrChecked(event, selectedModule, selectedSubmodule1, selectedSubmodule2, selectedSubmodule3)
  }

  checkSubmodule2IndeterminateOrChecked(event, selectedModule, selectedSubmodule1, selectedSubmodule2, selectedSubmodule3) {
    let sub3 = this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].menu3;
    let subModules3 = Object.keys(sub3);
    let isValid = true;
    for (let i = 0; i < subModules3.length; i++) {
      if ((!sub3[subModules3[i]].checked)) {
        isValid = false;
        break;
      } else {
        isValid = true;
      }
    }
    if (isValid) {
      this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].checked = isValid;
      this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].indeterminate = !isValid;
    } else {
      let arr = [];
      for (let i = 0; i < subModules3.length; i++) {
        arr.push(sub3[subModules3[i]].checked);
      }
      let value = arr.filter(e => e == true);
      if (value.length <= 0) {
        this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].indeterminate = isValid;
        this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].checked = isValid;
      } else if (value.length == subModules3.length) {
        this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].indeterminate = isValid;
        this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].checked = !isValid;
      } else {
        this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].indeterminate = !isValid;
        this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].checked = isValid;
      }
    }
    this.checkSubmodule1IndeterminateOrChecked(event, selectedModule, selectedSubmodule1);
  }
  submitFieldMap() {
    let obj = {
      orgID: this.orgID,
      fieldMap: this.tableData
    };
    let keys = Object.keys(this.tableData);
    let isValid = false;
    for (let i = 0; i < keys.length; i++) {
      if (this.tableData[keys[i]].checked || this.tableData[keys[i]].indeterminate) {
        isValid = true;
        break;
      } else {
        isValid = false;
      }
    }
    if (isValid) {
      this.api.org_settings_update(obj).then((res: any) => {
        if (res.status == 'success') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          this.router.navigate(['/master/organization/view-org']);
        }
        if (res.status == 'failure') {
          console.log('settings error');
          const msg = [];
          const rstmsg = res.message;
          console.log(rstmsg.orgID);
          rstmsg.orgID.forEach(function (eror) {
            console.log(eror);
            this.msg.push(eror);
          });

          this.swal.swalFunction('error', res.status, msg, 2000);
        }

      })
        .catch((err) => {
          console.log(err);
        });
    } else {
      this.swal.swalFunction('error', 'Failure', 'You must select atleast one module!', 2000);
    }
  }
  goBackToList() {
    this.router.navigateByUrl('master/organization/view-org');
  }

  selectSetting(value, setting, field) {
    if (field == 'checkbox') {
      if (setting == 'multiTripStart') {
        if (value == true) {
          this.general['multiTripStart'] = value;
        } else this.general['multiTripStart'] = value;
      }
      if (setting == 'empAppPolyline') {
        if (value == true) this.general['empAppPolyline'] = value; else this.general['empAppPolyline'] = value;
      }
      if (setting == 'clicktocall') {
        if (value == true) this.general['clicktocall'] = value; else this.general['clicktocall'] = value;
      }
      if (setting == 'breakDown') {
        if (value == true) this.general['breakDown'] = value; else this.general['breakDown'] = value;
      } if (setting == 'event') {
        if (value == true) this.general['event'] = value; else this.general['event'] = value;
      }
      if (setting == 'selfAttendanceForEmp') {
        if (value == true) this.general['selfAttendanceForEmp'] = value; else this.general['selfAttendanceForEmp'] = value;
      }
      if (setting == 'harshAccBraking') {
        if (value == true) {
          this.general['harshAccBraking'] = value,
          this.brakingDisable = true;
        }
        else { this.general['harshAccBraking'] = value,  this.brakingDisable = false; }
      }
    }
    if (field == 'select') {
      this.general['empAttendance'] = value;
    }
    if (field == 'input'&& setting == 'driverTokenExp') {
      let parVal = value;
      if (parseInt(parVal) > 10) {
        this.disableTrue = true;
      } else {
        this.disableTrue = false;
        this.general['driverTokenExp'] = +value;
      }
    }
    if (field == 'input' && setting == 'timeIntrevel') {
      let timeIntrevel = value;
      if (parseInt(timeIntrevel) > 300) {
        this.disableTrue2 = true;
        this.errorContent = 'The maximum allowed should be only 300 seconds!';
      } else if (parseInt(timeIntrevel) == 0) {
        this.disableTrue2 = true;
        this.errorContent = 'The minimum allowed should be 10 seconds!';
      }
      else {
        this.disableTrue2 = false;
        this.general['driverTrackingInterval'] = +value;
      }
    }
    if (field == 'input' && setting == 'harshAccThreshold') {
      let checkValue = value;
      if (checkValue < 0.08) {
        this.disableTrue3 = true;
        this.errorContentHarshAcc = 'The minimum allowed value should be 0.08 m/s²!';
      } else {        
        this.disableTrue3 = false;
        this.general['harshAccThreshold'] = +value;
      }
    }
    if (field == 'input' && setting == 'harshBrakingThreshold') {
      let checkValue = value;
      if (checkValue < 0.08) {
        this.disableTrue4 = true;
        this.errorContentHarshBreak = 'The minimum allowed value should be 0.08 m/s²!';
      } else {        
        this.disableTrue4 = false;
        this.general['harshBrakingThreshold'] = +value;
      }
    }
  }
  submitgeneralSettings() {
    let obj = {
      orgID: this.orgID,
      general: this.general
    }
    this.api.updateOrg(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.router.navigate(['/master/organization/view-org']);
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 2000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }

}


